import React, { useRef, useEffect } from "react";
import { useLocation } from "react-router-dom";
import CareerHero from "../components/CareerPage/CareerHero";
import OurStory from "../components/CareerPage/OurStory";
import Boot41 from "../components/CareerPage/Boot41";
import Boot41FlowFrame from "../components/CareerPage/Boot41FlowFrame";
import LifeAtThink41 from "../components/CareerPage/LifeAtThink41";
import ellipse from "../assets/Career/Ellipse.svg";

const CareerPage = () => {
  const boot41Ref = useRef(null);
  const location = useLocation();

  useEffect(() => {
    if (location.hash === "#boot41" && boot41Ref.current) {
      boot41Ref.current.scrollIntoView({ behavior: "smooth" });
    }
  }, [location]);

  return (
    <div>
      <CareerHero boot41Ref={boot41Ref} />
      <OurStory />
      <div ref={boot41Ref}>
        <Boot41 />
      </div>
      <Boot41FlowFrame />
      <div style={{ height: 16 }} />
      <LifeAtThink41 />
    </div>
  );
};

export default CareerPage;
